import React from 'react';
import { CircleAlert } from 'lucide-react';

export type InvasiveSpeciesIconProps = {
    className?: string;
};

const InvasiveSpeciesIcon = ({ className = 'text-red-100' }: InvasiveSpeciesIconProps) => {
    return <CircleAlert className={className} />;
};

export default InvasiveSpeciesIcon;
